import {API_URL, apiGet} from '../api'

// GET /v3/admin/feed_templates?kind= — 해당 kind의 전체 템플릿(active/inactive 모두) 반환.
export const getFeedTemplates = async (kind: string) => {
    return await apiGet(API_URL, `admin/feed_templates?kind=${encodeURIComponent(kind)}`)
}
